import { sendToApi } from 'api/client'
import { AIJobStatus } from 'types'

export type BlogMetadataRecord = {
  title?: string
  author?: string
  summary?: string
  tags?: string[]
  category?: string
  categories?: string[]
  seo_words?: string[]
  launch_date?: string
  url_slug?: string
  featured_media?: FeaturedMedia
  status?: AIJobStatus
  failure_reason?: string
  selected_blog_id?: string
  selected_author_id?: string
}

export type FeaturedMedia = {
  featured_selected_images?: { url: string; alt_text: string }[]
  alt_text?: string
  current_featured_image?: string
  image_mood?: string
  image_type?: string
  image_style?: string
  include_images?: boolean
  image_aspect_ratio?: string
  initial_media_file_id?: string
}

export type GoHighLevelBlog = {
  id: string
  name: string
  url?: string
  location_id?: string
  updated_at?: string
}

export type GoHighLevelAuthor = {
  id: string
  name: string
  email?: string
  location_id?: string
  updated_at?: string
  canonical_link?: string
}

export type WixMember = {
  id: string
  name: string
  slug?: string
  photo_url?: string
  contact_id?: string
  status?: string
}

export type ShopifyBlog = {
  id: string
  name: string
  url?: string
}

export type ShopifyAuthor = {
  id: string
  name: string
  email?: string
}

export type WordPressUser = {
  id: number
  name: string
  slug: string
}

export type BlogMetadataRecordsParams = Partial<BlogMetadataRecord>

export const BlogMetadataRecordsClient = {
  get: async ({ articleId }: { articleId: string }) => {
    const res = await sendToApi<BlogMetadataRecord>(`/articles/${articleId}/blog_metadata_record`, {
      method: 'GET',
    })

    return res
  },
  update: async ({ articleId, params }: { articleId: string; params: BlogMetadataRecordsParams }) => {
    const res = await sendToApi<BlogMetadataRecord>(`/articles/${articleId}/blog_metadata_record`, {
      method: 'POST',
      body: params,
    })

    return res
  },
}
